.list {
  display: flex;
  align-items: center;
  min-width: 0;
  flex-shrink: 0;
}

.barList {
  gap: var(--spacing-xs);
  padding: 0 var(--spacing-sm);
  border-bottom: 1px solid var(--color-border);
  background: var(--color-surface-sunken);
  overflow-x: auto;
}

.modeList {
  gap: var(--spacing-xs);
  padding: 3px;
  border: 1px solid var(--color-border);
  border-radius: var(--radius-lg);
  background: var(--color-surface-sunken);
}

.tab {
  display: inline-flex;
  align-items: center;
  gap: var(--spacing-sm);
  flex: none;
  border: 0;
  background: transparent;
  color: var(--color-text-muted);
  font-weight: var(--font-weight-medium);
  white-space: nowrap;
  transition:
    background-color var(--transition-fast),
    color var(--transition-fast);
}

.tab:hover:not(.selected) {
  background: var(--color-surface-hover);
  color: var(--color-text);
}

.bar {
  min-height: var(--tabbar-height);
  padding: 0 var(--spacing-md);
  border-bottom: 3px solid transparent;
  font-size: var(--font-size-sm);
}

.bar.selected {
  border-bottom-color: var(--color-primary);
  color: var(--color-text);
  font-weight: var(--font-weight-semibold);
}

.mode {
  min-height: calc(var(--hit-target) - 6px);
  padding: 0 var(--spacing-md);
  border-radius: var(--radius-md);
  font-size: var(--font-size-md);
}

.mode.selected {
  background: var(--color-primary);
  color: var(--color-on-primary);
  font-weight: var(--font-weight-semibold);
  box-shadow: var(--shadow-sm);
}

@media (max-width: 1200px) {
  .mode .label {
    display: none;
  }
}
